module.exports = __webpack_public_path__ + "static/1-ba095584f8e286d394f0b6f60250bdc3.jpg";